<template>
  <div class="col-lg-7" id="userFields">
    <div class="row field-row mb-2 align-items-center">
      <div class="col-4">
        <div class="field-title">Primary Field:</div>
      </div>
      <div class="col-8">
        <select ref="primaryFieldSelect" v-model="newOptions.primaryField" data-width="100%" class="selectortype selectpicker bg-white">
          <option v-for="f in initialStepOptions.primaryFields" :key="f" :value="f">{{ f }}</option>
        </select>
      </div>
    </div>

    <div class="row field-row mb-2 align-items-center">
      <div class="col-4">
        <div class="field-title">Additional fields:</div>
      </div>
      <div class="col-8">
        <select ref="additionalFieldsSelect" v-model="newOptions.additionalFields" data-width="100%" class="selectortype selectpicker bg-white" multiple>
          <option v-for="f in initialStepOptions.additionalFields" :key="f" :value="f">{{ f }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userFields',
  props: ['stepsObj', 'stepOptions', 'blockClass'],
  data: function () {
    return {
      stepName: 'User Fields',
      newOptions: {
        primaryField: null,
        additionalFields: [],
      }
    };
  },
  mounted: function () {
    this.newOptions = { ...this.newOptions, ...this.stepOptions };
    $(this.$refs.primaryFieldSelect).selectpicker('val', this.newOptions.primaryField);
    $(this.$refs.additionalFieldsSelect).selectpicker('val', this.newOptions.additionalFields);
  },
  computed: {
    step: function () {
      if (this.blockClass.length > 0) {
        return {
          blockClass: this.blockClass,
          options: { ...this.newOptions }
        };
      }
    },
    initialStepOptions: function () {
      return this.stepsObj.find(step => step.blockClass === this.blockClass).stepOptions;
    },
  }
};
</script>
